import { render } from "./CounterSquared.vue?vue&type=template&id=949cd046"
import script from "./CounterSquared.vue?vue&type=script&lang=js"
export * from "./CounterSquared.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benny\\Documents\\Programmieren\\Vue\\cellCalculator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__